import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { BaseDataService, BaseTabs2UpdateComponent, ModalService, Tabs2ContainerService, UserService } from 'yt-ng-framework';
import { CompanyZrc } from './company_zrc_new';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-company-zrc-new-tab-update',
  templateUrl: './company-zrc-new-tab-update.component.html'
})
export class CompanyZrcNewTabUpdateComponent extends BaseTabs2UpdateComponent<CompanyZrc> implements OnInit {

  constructor(protected activatedRoute: ActivatedRoute,
      protected tabsContainerService2: Tabs2ContainerService<CompanyZrc>,
      protected baseDataService: BaseDataService,
      protected userService: UserService,
      protected modalService: ModalService,
      protected changeDetectorRef: ChangeDetectorRef
      ) { 
        super(tabsContainerService2, baseDataService);
      }

      // protected tabsContainerService: Tabs2ContainerService<CompanyZrc>,
      // protected baseDataService: BaseDataService,
      // protected userService: UserService,
      // protected modalService: ModalService,
      // ) { 
      //   super(activatedRoute, tabsContainerService, baseDataService, userService);
      // }

  
  ngOnInit() {
    super.ngOnInit();
    if (this.defaultUpdateButtons){
      this.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Visible=false;
      this.defaultUpdateButtons.ButtonsConfig.LockButtonConfig.Visible=false;
      this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
      this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
    }
   }

  // ngAfterViewInit() {
  //   this.baseUpdateComponent.buttonsConfig.LockButtonConfig.Visible = false;
  //   this.baseUpdateComponent.buttonsConfig.ContextMenuButtonConfig.Visible = false;
  //   this.changeDetectorRef.detectChanges();
  // }

  

}
